module.exports = {
  VERSION:          '1.2.2',

  BAYEUX_VERSION:   '1.0',
  ID_LENGTH:        160,
  JSONP_CALLBACK:   'jsonpcallback',
  CONNECTION_TYPES: ['long-polling', 'cross-origin-long-polling', 'callback-polling', 'websocket', 'eventsource', 'in-process'],

  MANDATORY_CONNECTION_TYPES: ['long-polling', 'callback-polling', 'in-process']
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/util/constants.js
 ** module id = 1
 ** module chunks = 0
 **/